export default {
      id: "oc-res-ipv6-gateway-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-ipv6-gateway",
      toString: function () {
        return this.url;
      }
    }